import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { EstimationVendorWiseModel } from 'src/app/models/department-reports.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-estimation-vendor-wise-report',
  templateUrl: './estimation-vendor-wise-report.component.html',
  styleUrls: ['./estimation-vendor-wise-report.component.scss']
})
export class EstimationVendorWiseReportComponent implements OnInit {
  totalApp:number;
  verfApp:number;
  onTime:number;
  pendingByWeek:number;
  pendingMoreThanWeek:number;
  estAmount:number;
  miArea:number;
  grandTotalApp:number;
  grandVerfApp:number;
  grandOnTime:number;
  grandPendingByWeek:number;
  grandPendingMoreThanWeek:number;
  grandEstAmount:number;
  grandMiArea:number;
  arrayIndex:number;
  tempVendorWise: any[];
  vendorWise: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: EstimationVendorWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  public subscriptions: any = [];
  public loading: boolean = false;
  public userID: any;
  value:any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  displayMaximizable_pendingApp:boolean;
  pendingType:any;
  drilldownDetails:any;
  vendorName:any;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Vendor_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }
  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getEstimation_VendorWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Estimations Report (Vendor Wise)', '', new Date(), 'Success');


            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.vendorWise = data;
              this.appVerificationModel = data;
              this.tempVendorWise=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.vendorWise =[] ;
              this.appVerificationModel = [];
              this.tempVendorWise=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Estimations Report (Vendor Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Vendor Name" : d.VendorName,
          "Total Application": d.TotalApplication,
          "Verified Application": d.VerifiedApplication,
          "On Time": d.PendingEarly,
          "Pending by one Week": d.Pending_1Week,
          "Pending more than one Week": d.Pending_Morethan_1Weeks,
          "Est Amount": d.Est_Amount,
          "Mi Area": d.Mi_Area,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'VendorName', header: 'Vendor Name'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'VerifiedApplication', header: 'Verified Application' },
      { field: 'PendingEarly', header: 'On Time' },
      { field: 'Pending_1Week', header: 'Pending by one Week' },
      { field: 'Pending_Morethan_1Weeks', header: 'Pending More than one Weeks' },
      { field: 'Est_Amount', header: 'Est Amount' },
      { field: 'Mi_Area', header: 'Mi Area' },
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempVendorWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalApp=0;
        this.verfApp=0;
        this.onTime=0;
        this.pendingByWeek=0;
        this.pendingMoreThanWeek=0;
        this.estAmount=0;
        this.miArea=0;
        for(let i=this.arrayIndex ;this.tempVendorWise.length>10?i<this.arrayIndex+10:i<this.tempVendorWise.length;i++) {
          //console.log( this.totalApp,"totalAPPPPPPPPP")
          this.totalApp +=this.tempVendorWise[i].TotalApplication;
          this.verfApp +=this.tempVendorWise[i].VerifiedApplication;
          this.onTime += this.tempVendorWise[i].PendingEarly;
          this.pendingByWeek += this.tempVendorWise[i].Pending_1Week;
          this.pendingMoreThanWeek += this.tempVendorWise[i].Pending_Morethan_1Weeks;
          this.estAmount += this.tempVendorWise[i].Est_Amount;
          this.miArea +=this.tempVendorWise[i].Mi_Area;

        }      
    }
    calculateGrandTotal(){
      this.grandTotalApp=0;
      this.grandVerfApp=0;
      this.grandOnTime=0;
      this.grandPendingByWeek=0;
      this.grandPendingMoreThanWeek=0;
      this.grandEstAmount=0;
      this.grandMiArea=0;
      for(let vendorData of this.tempVendorWise) {
        this.grandTotalApp += vendorData.TotalApplication;
        this.grandVerfApp += vendorData.VerifiedApplication;
        this.grandOnTime += vendorData.PendingEarly;
        this.grandPendingByWeek += vendorData.Pending_1Week;
        this.grandPendingMoreThanWeek += vendorData.Pending_Morethan_1Weeks;
        this.grandEstAmount += vendorData.Est_Amount;
        this.grandMiArea += vendorData.Mi_Area;
    }
    }
    showMaximizableDialog(value:any,status:any,vendorName:any) {
      
      this.vendorName=vendorName
      this.value=value;
      this.drilldownDetails={
        actionType:"Estimation",
        
        filterType:"Vendor",
        value:this.value,
        status:status,
        MIType:""
      }
      
      this.displayMaximizable = true;
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_totalApp(value:any,vendorName:any) {
      
      
    this.value=value;
    this.vendorName=vendorName
    this.drilldownDetails={
      actionType:"Estimation",
      
      filterType:"Vendor",
      value:this.value,
      MIType:""
    }
    
    this.displayMaximizable_totalApp = true;

    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")

}
showMaximizableDialog_pending(value:any,duration:any,vendorName:any) {
  this.vendorName=vendorName
  if(duration=='early'){
    this.pendingType='On Time'
  }
  if(duration=='1Week'){
    this.pendingType='Pending by Week'
  }
  if(duration=='morethan_1Week'){
    this.pendingType='Pending more than one Week' 
  }
  this.value=value;
  this.drilldownDetails={
    actionType:"Estimation",
    
    filterType:"Vendor",
    value:this.value,
    duration:duration,
    MIType:""
  }
  
  this.displayMaximizable_pendingApp = true;
  // console.log(this.value,"value")
  // console.log(this.drilldownDetails,"this.drilldownDetails")

}

}
